import { render, staticRenderFns } from "./UserSettingsInfo.vue?vue&type=template&id=3826c83e&"
import script from "./UserSettingsInfo.vue?vue&type=script&lang=js&"
export * from "./UserSettingsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports